






























import { Component, Prop, Vue } from "vue-property-decorator";
import { UncertaintyPhrase } from "../../../types/NewResults";

// import AssetsMixin from "@/AssetsMixin";
// import Card from "../Card.vue";

@Component({
  components: {}
})
export default class Directness extends Vue {
  @Prop() private uncertainty!: UncertaintyPhrase[];
  private created() {
    console.log(this.uncertainty);
  }
}
